import { Card } from "@peer-start/ui";
import { AlertCircle, LoaderCircle } from "lucide-react";
import { useTranslation } from "react-i18next";

export function AdministrationLoading() {
  const { t } = useTranslation();
  return (
    <div className="grid min-h-64 place-items-center" role="status">
      <span className="flex items-center gap-2 font-medium text-muted-foreground">
        <LoaderCircle aria-hidden="true" className="size-5 animate-spin" />
        {t("common.loading")}
      </span>
    </div>
  );
}

export function AdministrationError() {
  const { t } = useTranslation();
  return (
    <Card className="flex items-start gap-3 bg-destructive text-destructive-foreground" role="alert">
      <AlertCircle aria-hidden="true" className="mt-0.5 size-5 shrink-0" />
      <div>
        <h1 className="font-medium">{t("common.error")}</h1>
        <p className="mt-1 text-sm">{t("administration.loadError")}</p>
      </div>
    </Card>
  );
}
